import React, { useState, useEffect } from 'react';
import { Collapse, CardBody, CardHeader } from 'reactstrap';
import { Row, Col, Container, Card } from 'reactstrap';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import { css } from 'emotion';
import { LargeBusiness, htmlWidget } from '../../Constants';
import { pushAccordionTrackEvent } from '../../utils/Analytics';


function EirAccordionTile(props) {
    const renderContent = (content) => {
        return { __html: content };
    }
    let plus, hc;
    const [isOpen, setOpen] = useState(false);
    const collapseLb = LargeBusiness.isLBSite ? "eir-collapselb-content" : "";
    let accordionTitle = props && props.Heading && props.Heading.toString();
    let url = window.location.href;

    function removehover(id, index1, index2) {
        if (document.getElementById('eir-accordion-ctr-' + id + index1 + '.' + index2).classList.contains("accordion-tile-title")) {
            document.getElementById('eir-accordion-ctr-' + id + index1 + '.' + index2).classList.remove("accordion-tile-title");
        }
        else {
            document.getElementById('eir-accordion-ctr-' + id + index1 + '.' + index2).classList.add("accordion-tile-title");
        }
    }

    if (!isOpen) {
        switch (true) {
            case (window.location.pathname == "/business/"): {
                plus = <span className=" eir-icon eir-icon--sm icon-arrowdown--black float-right " />;
                hc = 'accordion-hover-b';
                break;
            }
            case (LargeBusiness.isLBSite): {
                plus = <span className=" eir-icon eir-icon--sm navigation-icon-lb " />;
                hc = <span className=" eir-icon eir-icon--sm accordion-hover-lb rotate " />;
                break;
            }
            case (window.location.href.indexOf("/business/") > 0 && LargeBusiness.isLBSite): {
                plus = <span className=" eir-icon eir-icon--sm navigation-icon-sb " />;
                hc = 'accordion-hover-smb';
                break;
            }
            default: {
                // plus = <span className=" eir-icon eir-icon--sm navigation-icon-eir " />;
                plus = (
                        <span
                            className="eir-icon eir-icon--sm navigation-icon-eir"
                            role="button"
                            tabIndex={0}
                            aria-expanded={isOpen}
                            onClick={() => setOpen(!isOpen)}
                            onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setOpen(!isOpen);
                            }
                            }}
                        />
                        );
                hc = 'accordion-hover-eir';
            }
        }
    } else {
        // pushAccordionTrackEvent(accordionTitle, url);
        switch (true) {
            case (window.location.pathname == "/business/"): {
                plus = <span className=" eir-icon eir-icon--sm icon-arrowdown--black float-right rotate " />;
                hc = 'accordion-hover-b';
                break;
            }
            case (LargeBusiness.isLBSite): {
                plus = <span className=" eir-icon eir-icon--sm navigation-icon-lb rotate " />;
                hc = <span className=" eir-icon eir-icon--sm accordion-hover-lb rotate " />;
                break;
            }
            case (window.location.href.indexOf("/business/") > 0 && LargeBusiness.isLBSite): {
                plus = <span className=" eir-icon eir-icon--sm navigation-icon-sb rotate " />;
                hc = 'accordion-hover-smb';
                break;
            }
            default: {
                // plus = <span className=" eir-icon eir-icon--sm navigation-icon-eir float-right rotate " />;
                plus = (
                        <span
                            className=" eir-icon eir-icon--sm navigation-icon-eir float-right rotate "
                            role="button"
                            tabIndex={0}
                            aria-expanded={isOpen}
                            onClick={() => setOpen(!isOpen)}
                            onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setOpen(!isOpen);
                            }
                            }}
                        />
                        );
                hc = 'accordion-hover-eir';
            }
        }
    }

    const paddingLb = LargeBusiness.isLBSite ? "p-lb" : "";
    const marginLb = LargeBusiness.isLBSite ? "m-lb" : "";
    const paddZeroLb = LargeBusiness.isLBSite ? "p-0-lb" : "";
    return (
        <div className="p-1 accordion-tile ">
            <Card className={` accordion-tile-card ` + ((isMobileOnly) || ((isTablet)) ? (' ml-3 mr-3 p-0  ' + ((!isOpen) && ' accordion-tile-bg-color ')) : (' ml-5 mr-5 p-0 ' + ((!isOpen) && ` ${hc} `)))} >
                {(props.Heading != undefined && !(props.Copy)) &&
                    <Row id={"eir-accordion-ctr-" + props.id + props.index1 + "." + props.index2} className={'p-0 col-12 ml-1 accordion-tile-title'} onClick={() => { ((props.Copy) && removehover(props.id, props.index1, props.index2)); ((props.Copy) && setOpen(!isOpen)) }} >
                        <Col className={' mt-0  col-12  pl-2 pr-0 ' + htmlWidget + ((!props.Copy) && ' headerlink-nocopy ')} dangerouslySetInnerHTML={renderContent(props.Heading)} ></Col>
                        {(props.Copy) &&
                            <Col className={'col-1 m-auto arrow-icon float-right  '}  >{plus}</Col>}
                    </Row>
                }

                {/* <a href={(!(props.Copy)) && props.Heading}> */}
                {(props.Heading != undefined && props.Copy) &&
                    <Row id={"eir-accordion-ctr-" + props.id + props.index1 + "." + props.index2} className={` col-12 p-1 ml-1 accordion-tile-title ${paddingLb} `} onClick={() => { ((props.Copy) && removehover(props.id, props.index1, props.index2)); ((props.Copy) && setOpen(!isOpen)) }} >
                        <Col className={` mt-2  col-11  pl-2 pr-3 header-withcopy ${marginLb} ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(props.Heading)} ></Col>
                        {(props.Copy) &&
                            <Col className={`col-1 m-auto arrow-icon float-right ${paddZeroLb}`}  >{plus}</Col>}
                    </Row>
                }                
                     <Collapse
                    isOpen={isOpen}
                    aria-hidden={!isOpen}
                     >
                    {props.Copy != undefined &&
                        <div className={` ml-3 mr-3 pr-3 ${collapseLb} `} >
                            <div className={' accordion-subcopy-card acc-subcopy ' + htmlWidget} dangerouslySetInnerHTML={renderContent(props.Copy)} >
                            </div>
                        </div>
                    }
                </Collapse>
                {/* </a> */}
            </Card>
        </div >
    )

}
export default EirAccordionTile;